import type { ScheduleItemV2 } from '@hopin-team/api-hopin';
import { isAfter } from 'date-fns';

export const shouldRenderAddToCalendar = (item: ScheduleItemV2) =>
  isAfter(new Date(item.time_end), Date.now()) &&
  item.event_part_type !== 'break';
